import React, {useEffect, useState} from "react";
import {
  saveNewQuantityInCart,
  saveNewQuantityInCartOffer
} from "./UtilsForCart";

interface ComponentProps {
  quantityInCart: number,
  variantCode: string,
  tokenValue: string,
  dispatch: any,
  isCartQuantity: boolean
  itemOrderId?: any
}

const ButtonsQuantityMultiple: React.FC<ComponentProps> = ({quantityInCart, variantCode, tokenValue, dispatch, isCartQuantity, itemOrderId}: ComponentProps) => {
  const [counter, setCounter] = useState(quantityInCart);
  const [showSaveButton, setShowSaveButton] = useState(false)

  useEffect(() => {
    if (counter !== quantityInCart) {
      setShowSaveButton(true);
    } else {
      setShowSaveButton(false);
    }
  }, [counter, quantityInCart]);

  const decCounter = (e:any) => {
    e.preventDefault()
    setCounter(counter - 1)
  }
  const incCounter = (e:any) => {
    setCounter(counter + 1)
  }
  return(
    <div className="flex-row d-flex"  key={variantCode}>
      <div className="col-auto">
        <div className="input-group input-spinner">
          <button className="btn btn-icon btn-light" type="button" onClick={(e) => decCounter(e)}
                  disabled={counter === 1}>
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="#999" viewBox="0 0 24 24">
              <path d="M19 13H5v-2h14v2z"></path>
            </svg>
          </button>
          <input
            className="btn-quantity form-control text-center"
            value={counter}
            onChange={(e) => {
              const value = e.target.value;
              const newValue = parseInt(value, 10);
              if (!isNaN(newValue) && newValue >= 1) {
                setCounter(newValue);
              }
            }}
          />
          <button className="btn btn-icon btn-light" type="button" onClick={(e) => incCounter(e)}>
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="#999"
                 viewBox="0 0 24 24">
              <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"></path>
            </svg>
          </button>
        </div>
      </div>
      <div className="col">
        {
          showSaveButton ?
            isCartQuantity ?
              saveNewQuantityInCart(counter, itemOrderId, tokenValue, dispatch)
              :
              saveNewQuantityInCartOffer(counter, variantCode, tokenValue, dispatch)
            : null
        }
      </div>
    </div>
  )
}

export default ButtonsQuantityMultiple;
